var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.1 137.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #ff3d29;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #233d6a;\r\n      }\r\n\r\n      .st3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 7px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 6.6,
    y: 6.6,
    width: 125,
    height: 123.9,
    rx: 57.2,
    ry: 57.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 69.9,
    cy: 69.6,
    r: 55.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,59.9l.5.2c1.2,1.5,3.3,3,4.5,4.5.2.2.3.4,0,.6l-24.3,24.3-15.1-15v-.3l4.8-4.7h.2l9.9,9.7h.3l19.1-19.1v-.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,95.3c.5-1.2,1.3-2.3,1.9-3.5,6.4-13.3,6.8-28.8.8-42.3-.8-1.9-1.9-3.7-2.8-5.6h5.5s0,0,.2,0c8.3,15.9,8.6,35.7,0,51.6h-5.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.4,113.6v5.7c-3.5,1.6-7.1,3.1-10.8,4.2-13.3,3.5-27.4,2-39.5-4.2v-5.7c1.5.7,2.9,1.5,4.3,2.2,13.3,6.1,28.6,5.9,41.9,0s2.8-1.5,4.3-2.1h-.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.4,25.3c-3.4-1.9-7.1-3.4-10.8-4.4-11.3-3-23.3-2.2-33.9,2.6l-5.5,2.8v-5.6c1.4-.9,3-1.6,4.7-2.3,14.5-6.1,31.6-5.7,45.7,1.4v5.6h-.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,44.1l-2.9,5.9c-5.9,14-5.2,30.4,2,43.7h-5.7c-7.3-15.5-7.3-34.5,1-49.7h5.6,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.7,56.1H10.5c-.3,0-1.2-.5-1.4-.8-1.4-1.2-1.8-3.5-.8-5.1l15.3-15.3L1.8,13,13.3,1.3l21.9,21.7,15-14.8c2.1-1.7,5.4-1.2,6.4,1.4s0,1.3,0,2.2v44.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.5,84.2v1.3c0,0,0,44.1,0,44.1,0,3.2-3.7,5-6.3,3l-15.1-14.9-20.7,20.5L-.3,126.5l20.7-20.8-14.4-14.6c-1.8-1.8-1.7-5.1.6-6.5s1.5-.5,1.8-.5h45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.2,56.5V10.7c0-.3.6-1.3.9-1.7,1.2-1.4,3.3-1.8,4.9-.8l15.5,15.3L124.9,3.4l11.8,11.7-20.4,20.4,15,15.1c1.4,2.2.8,5.3-1.8,6.2h-24.5l-1.3-.3h-20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,84.3h46.1c.3,0,1.4.6,1.7.9,1.3,1.2,1.5,3.2.8,4.7l-15.4,15.7,18,18-11.5,11.7-18.2-18.1-15.1,15.1c-1.7,1-4,1-5.3-.4s-1-1.7-1-1.9v-45.6l.3-.3h0l-.3.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,55.7H10.9c-.3,0-1.2-.5-1.4-.8-1.4-1.2-1.8-3.5-.8-5.1l15.3-15.3L2.2,12.6,13.7.9l21.9,21.7,15-14.8c2.1-1.7,5.4-1.2,6.4,1.4s0,1.3,0,2.2v44.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.9,83.8v1.3c0,0,0,44.1,0,44.1,0,3.2-3.7,5-6.3,3l-15.1-14.9-20.7,20.5L.1,126.1l20.7-20.8-14.4-14.6c-1.8-1.8-1.7-5.1.6-6.5s1.5-.5,1.8-.5h45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,56.1V10.3c0-.3.6-1.3.9-1.7,1.2-1.4,3.3-1.8,4.9-.8l15.5,15.3L125.3,3l11.8,11.7-20.4,20.4,15,15.1c1.4,2.2.8,5.3-1.8,6.2h-24.5l-1.3-.3h-20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.1,83.9h46.1c.3,0,1.4.6,1.7.9,1.3,1.2,1.5,3.2.8,4.7l-15.4,15.7,18,18-11.5,11.7-18.2-18.1-15.1,15.1c-1.7,1-4,1-5.3-.4s-1-1.7-1-1.9v-45.6l.3-.3h0l-.3.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPick);
export default __webpack_public_path__ + "static/media/pick.5e5ba7afd5d4717579440fa7093fd6b1.svg";
export { ForwardRef as ReactComponent };